import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import EditColumnsModal from './EditColumnsModal';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { trackDealTableEditColumnsOpen } from '../../utils/usageTracker';
import { fetchPropertyGroups } from '../../actions/PropertiesActions';
import { getPropertyGroupsStatus } from '../../selectors/properties';
import { UNINITIALIZED } from '../../constants/RequestStatusTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EditColumnsButton = () => {
  const dispatch = useDispatch();
  const isDealStageView = useSelector(getIsDealStageView);
  const propertyGroupsStatus = useSelector(getPropertyGroupsStatus);
  const [editModalOpen, setEditModalOpen] = useState(false);
  useEffect(() => {
    if (propertyGroupsStatus === UNINITIALIZED) {
      dispatch(fetchPropertyGroups()).catch(() => {
        /* handled in fetchPropertyGroups */
      });
    }
  }, [dispatch, propertyGroupsStatus]);
  const openEditModal = useCallback(() => {
    setEditModalOpen(true);
    trackDealTableEditColumnsOpen(isDealStageView);
  }, [isDealStageView]);
  const closeEditModal = useCallback(() => setEditModalOpen(false), []);
  const button = /*#__PURE__*/_jsxs(UIButton, {
    className: "m-left-3",
    "data-selenium-test": "configure-columns-button",
    onClick: openEditModal,
    size: "xs",
    use: "tertiary-extra-light",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "editColumns"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "configureColumns.edit"
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [editModalOpen && /*#__PURE__*/_jsx(EditColumnsModal, {
      onClose: closeEditModal
    }), button]
  });
};
export default EditColumnsButton;